import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FloatingWhatsApp.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../config';

const FloatingWhatsApp = () => {
  const [phoneNumber, setPhoneNumber] = useState(null); // État pour stocker le numéro de téléphone

  useEffect(() => {
    const fetchAdminPhone = async () => {
      try {
        const response = await axios.get(`${config.SITE_API_URL}/admin-phone`,{
            headers: { 
            'x-api-key': config.SITE_API_KEY
           }});
        if (response.data.success) {
          // Ajouter l'indicatif de pays si nécessaire (par exemple, +216 pour la France)
          const formattedPhone = `+216${response.data.phone}`; // Remplacez +216 par l'indicatif approprié
          setPhoneNumber(formattedPhone);
        } else {
          toast.error('Erreur lors de la récupération du numéro de téléphone de l\'admin.');
        }
      } catch (error) {
        toast.error('Erreur lors de la récupération du numéro de téléphone de l\'admin.');
      }
    };

    fetchAdminPhone();
  }, []);

  const whatsappLink = phoneNumber ? `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=Bonjour,%20je%20souhaite%20une%20assistance` : '#';

  return (
    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="floating-whatsapp">
      <img src="/assets/logowhatsapp.png" width={50} height={50} alt="" />
    </a>
  );
};

export default FloatingWhatsApp;